const array = [{ value: 'stock', label: 'На склад' }, { value: 'throw_a', label: 'В утиль' }, { value: 'repair', label: 'Починка' }]
exports.getArray = array
exports.getLabel = (v) => {
  const obj = array.find(e=>e.value===v)
  if (obj)
    return obj.label
  else return ''
}